module.exports = __webpack_public_path__ + "static/media/WhatsApp.0e878a0f.svg";